import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {  Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
// import { AiOutlineRight } from "react-icons/ai";
import Logo from "./Logo";
// import NavPanel from "./NavPanel";
// import NavSearch from "./NavSearch";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import utils from "utils";
import NavProfile from "./NavProfile";
import { Link, useHistory } from "react-router-dom";

const { Header } = Layout;

export const HeaderNav = (props) => {
  const history = useHistory();
  const {
    token,
    navCollapsed,
    mobileNav,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
  } = props;
  const navType = "TOP";
  const [searchActive, setSearchActive] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === "dark" ? "#00000" : "#ffffff"
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo mobileLogo={true} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  onClick={() => {
                    onToggle();
                  }}
                >
                  {navCollapsed || isMobile ? (
                    <MenuUnfoldOutlined className="nav-icon" />
                  ) : (
                    <MenuFoldOutlined className="nav-icon" />
                  )}
                </li>
              )}
            </ul>
          </div>
          <div className={isMobile ? "d-none" : "nav-right"}>
            <ul className="header-links">
              <li className="header-link">
                <Link to="/">Home</Link>
              </li>
              {/* <li className="header-link ml-4">
                <a href="https://partner.oneats.co/auth/login">Partner Login</a>
              </li> */}
              <li className="header-link ml-4">
                <Link to="/app/home/list-jobs" className="capitalized">
                  Jobs list
                </Link>
              </li>
              <li className="header-link ml-4">
                <Link to="/app/home/applied-jobs" className="capitalized">
                  Applied jobs
                </Link>
              </li>
              {token === null && (
                <div className="auth-wrapper">
                  <li
                    onClick={() => {
                      history.push("/auth");
                    }}
                    className="mr-0 header-link ml-4 capitalized"
                  >
                    Log in
                  </li>
                  <li className="header-link ml-4 mr-0 capitalized">
                    <button
                      onClick={() => {
                        history.push("/auth/register");
                      }}
                    >
                      Sign Up
                    </button>
                  </li>
                  <li className="header-link ml-4">
                    <div className="auth-wrapper">
                      <a
                        href="https://partner.oneats.co/auth/login"
                        target="_blank"
                        className="btn-link capitalized"
                      >
                        Partner Login
                      </a>
                    </div>
                  </li>
                </div>
              )}
              {token !== null && (
                <li className="header-link ml-4">
                  <NavProfile />
                </li>
              )}
            </ul>
            {/* {
              token !== null?<NavProfile />:
              <div className="auth-wrapper">
                <li onClick={()=>{ history.push("/auth")}}>Log in</li>
                <button onClick={()=>{history.push('/auth/register')}}>Sign Up
                  <AiOutlineRight/>
                </button>
            </div>  
            } */}

            {/* {token !== null ?<NavProfile />:<Button className="mt-3" type="primary"  onClick={()=>{
              history.push("/auth")
            }}>Login</Button>} */}
          </div>
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  const { token } = auth;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
    token,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
